import { Key } from 'react';
import { MenuItemType } from 'rc-menu/lib/interface';
import { useTranslation } from 'react-i18next';
import { OpDropdown } from 'components/customAntd/DLS/OpDropdown/OpDropdown';
import { OpSelect } from 'components/customAntd/DLS/OpSelect/OpSelect';
import { OpTextButton } from 'components/customAntd/DLS/OpTextButton/OpTextButton';

import './BatchActions.scss';

export interface IBatchActionsMenuItem extends Omit<MenuItemType, 'onClick'> {
  onClick(selectedRowKeys: Key[]): void;
}

interface IOpDataFetchTableProps {
  menuItems: IBatchActionsMenuItem[];
  selectedRowKeys: Key[];
  resetRowSelections(): void;
}

export const BatchActions = ({
  menuItems,
  selectedRowKeys,
  resetRowSelections,
}: IOpDataFetchTableProps) => {
  const { t } = useTranslation();

  return (
    <div className="batch-actions">
      <OpDropdown
        testId="batch-actions-dropdown"
        menu={{
          items: menuItems.map((item) => ({
            ...item,
            // Overwriting the onClick prop so we can pass selectedRowKeys
            onClick: () => item.onClick?.(selectedRowKeys),
          })),
          className: 'batch-actions__dropdown-menu',
        }}
        trigger={['click']}
        disabled={!selectedRowKeys.length}
      >
        {/** Using this as child so we get the consistent dropdown caret */}
        <OpSelect
          className="batch-actions__select"
          size="large"
          value={t('Batch actions')}
          notFoundContent={null}
          testId="batch-actions-select"
        />
      </OpDropdown>

      {/** Shows selected row count */}
      {selectedRowKeys.length > 0 && (
        <div className="batch-actions__text-container">
          <span className="batch-actions__selected-count">
            {selectedRowKeys.length} selected
          </span>
          <OpTextButton
            className="batch-actions__clear-button"
            onClick={resetRowSelections}
          >
            {t('Clear')}
          </OpTextButton>
        </div>
      )}
    </div>
  );
};
